import * as React from 'react'

const MaintenanceMode = () => {
  return (
    <div className='min-h-full px-4 py-16 sm:px-6 sm:py-24 md:grid md:place-items-center lg:px-8'>
      <div className='mx-auto max-w-max'>
        <main className='sm:flex'>
          <div className='sm:ml-6'>
            <div className='sm:pl-6'>
              <h1 className='text-4xl font-bold tracking-tight text-gray-900 sm:text-5xl'>
                We'll be right back
              </h1>
              <p className='mt-4 text-base text-gray-500'>
                We're currently performing scheduled maintenance to improve your
                experience.
              </p>
              <p className='mt-2 text-base text-gray-500'>
                Please check back in 30 minutes.
              </p>
            </div>
            <div className='mt-10 flex space-x-3 sm:border-l sm:border-transparent sm:pl-6'>
              <button
                onClick={() => window.location.reload()}
                className='cursor-pointer inline-flex items-center rounded-md border border-transparent bg-slate-700 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2'
              >
                Try again
              </button>
              <a
                href='https://useclip.com/contact'
                target='_blank'
                rel='noreferrer'
                className='cursor-pointer inline-flex items-center rounded-md border border-transparent bg-gray-100 px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2'
              >
                Contact support
              </a>
            </div>
          </div>
        </main>
      </div>
    </div>
  )
}

export { MaintenanceMode }
